import React, { lazy } from 'react';
import { Route } from 'react-router-dom';
import EPage from '@/enums/EPages';
import { PrivateRoute } from '@/hooks/useAuth';
import EBasicActions from '@/enums/EBasicActions';

const ConverterPage = lazy(() => import('@/containers/Views/Converters/ConverterPage'));

const ConverterRouter = (
  <Route path="converters">
    <Route
      index
      element={(
        <PrivateRoute
          pageName={EPage.Converters}
          permissions={EBasicActions.Find}
        >
          <ConverterPage />
        </PrivateRoute>
      )}
    />
  </Route>
);

export default ConverterRouter;
